import { Container } from "@mui/material";
import { checkMobile } from "../../utils/utils";

export default function Beian() {
  const is_phone = checkMobile();
  let style;
  let style_ = {};
  if (is_phone) {
    style = {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      alignItems: "center",
      height: "10vh",
      marginBottom: "10px",
    };
    style_ = {
      fontSize: "0.5rem",
      color: "#979797",
    };
  } else {
    style = {
      alignItems: "flex-end",
      justifyContent: "center",
      display: "flex",
      height: "20vh",
      marginBottom: "20px",
    };
  }
  return (
    <Container
      sx={{
        fontSize: "10px",
        ...style,
      }}
    >
      <p style={{ margin: 0, ...style_ }}>
        CopyRight © 2020 ~ 2026 Spectator&nbsp;&nbsp;
      </p>
      <p style={{ margin: 0 }}>
        <a style={{ ...style_ }} href="https://beian.miit.gov.cn/ ">
          渝ICP备2022008981号-2
        </a>
      </p>
    </Container>
  );
}
